import { useEffect, useState } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { Table, App, Button, Empty, Spin, Switch  } from "antd"
import { getSecurity, fetchPassword } from "@/apis/instance";
import { RightOutlined, FileTextOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useFormatter } from "@/hooks/useFormatter";

export const InstanceSecurityPanel = () => {
  const { formatDateTime } = useFormatter();
  const { modal } = App.useApp();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPWD, setIsLoadingPWD] = useState(""); 
  const [ipList, setIpList] = useState([]);
  const [tenantUsers, setTenantUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [tokens, setTokens] = useState([]);
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedInstance] } = state;
  const id = selectedInstance?.id;
  const ipWhiteListColumns = [
    {
      title: 'Public IP',
      dataIndex: 'ip',
      key: 'ip'
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note'
    }
  ];
  const tenantUserListColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%'
    },
    {
      title: 'Is Admin',
      dataIndex: 'isTenantAdmin',
      key: 'isTenantAdmin',
      render:(text, record) => {
        return ( record.isTenantAdmin && <CheckCircleOutlined/> );
      }
    }
  ];
  const userColumns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width:150,
    }, 
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      width:250,
    }, 
    {
      title: 'Password',
      dataIndex: 'password',
      key: 'password',
      render:(text, record) => <li>**************** 
        <Button style={{cursor:"pointer"}} type="default" icon={<FileTextOutlined/>} onClick={() => doFetchPwd(record.type, record.user)} size="small"/>
        {<Spin spinning={isLoadingPWD == `${record.type}:${record.user}`} indicator={<LoadingOutlined spin />} size="small" />}
        </li>
    } 
  ];
  const tokenColumns = [
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user'
    }, 
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label'
    }, 
    {
      title: 'Expired Time',
      dataIndex: 'expiredTime',
      key: 'expiredTime',
      width:160
    },
    { title: 'Token', dataIndex: 'token', key: 'token', width:200,
      render:(text, record) => <li>**************** <Button style={{cursor:"pointer"}} type="default" icon={<FileTextOutlined/>} onClick={() => modal.info({
        title: 'Token',
        content: `The token is ${text}`,
      })} size="small"/></li> },  
    {
      title: 'Created',
      dataIndex: 'created',
      key: 'created',
      render: (value) => formatDateTime(value),
      width:160
    }, 
    {
      title: 'LastUsed',
      dataIndex: 'lastUsed',
      key: 'lastUsed',
      render: (value) => formatDateTime(value),
      width:160
    } 
  ];
  useEffect(() => {
    const getSecurityInfo = async ( id ) => {
      try {
        setIsLoading(true);
        const response = await getSecurity(id);
        setIsLoading(false);
        if (response.status === "OK") {
          setIpList(response.value?.whitelist || []);
          setTenantUsers(response.value?.tenantUsers || []);
          setUsers(response.value?.builtInUsers || []);
          let t = response.value?.tokens || [];
          t = t.flatMap((item) => item.tokens&&item.tokens.length>0?(item.tokens.map((t) => (t.user = item.user)&&t)):(item.tokens?{user:item.user}:item));
          setTokens(t);
        } else {
          setIpList([]);
          setUsers([]);
          setTokens([]);
        }
      } catch (error) {
        console.error("get Security failed:", error);
      }
    };

    getSecurityInfo(id);
  }, [id]);

  const doFetchPwd = async (type, user) => {
    setIsLoadingPWD(`${type}:${user}`);
    const response = await fetchPassword(id, type, user);
    setIsLoadingPWD("");
    if (response.status === "OK") {
      modal.info({
        title: 'Password',
        content: `The password of user ${user} is ${response.value}`,
      });
    } else {
      modal.warning({
        title: 'Error',
        content: `Faied to fetch password for user ${user}. ${response.message}`,
      });
    }
  };

  return (
    <div>
      {(!selectedInstance || !isLoading && ipList.length < 1 && users.length < 1 && tokens.length < 1) && <Empty description={false} /> }
      { isLoading && <Spin size="large" /> }
      {selectedInstance && !isLoading && id.startsWith("i") && <div><RightOutlined/> IP White List</div> }
      {selectedInstance && !isLoading && id.startsWith("i") && <Table dataSource={ipList} size="small" columns= {ipWhiteListColumns}/>}
      {selectedInstance && tenantUsers.length > 0 && <div><RightOutlined/> Tenant Users </div> }
      {selectedInstance && tenantUsers.length > 0 && <Table dataSource={tenantUsers} size="small" columns= {tenantUserListColumns}/>}
      {selectedInstance && users.length > 0 && <div><RightOutlined/> Built-in Users & Passwords</div> }
      {selectedInstance && users.length > 0 && <Table dataSource={users} size="small" columns= {userColumns}/> }
      {selectedInstance && tokens.length > 0 && <div><RightOutlined/> User's Tokens</div> }
      {selectedInstance && tokens.length > 0 && <Table size="small"
      columns={tokenColumns}
      dataSource={tokens}
    />}
    </div>
  );
}; 
